import { render, staticRenderFns } from "./HeaderInfo.vue?vue&type=template&id=6f5ead4a&scoped=true"
import script from "./HeaderInfo.vue?vue&type=script&lang=js"
export * from "./HeaderInfo.vue?vue&type=script&lang=js"
import style0 from "./HeaderInfo.vue?vue&type=style&index=0&id=6f5ead4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5ead4a",
  null
  
)

export default component.exports